<div class="login-card" artemisThemeSwitcher>
  <artemis-loading-spinner *ngIf="loading$ | async"></artemis-loading-spinner>
  <div class="login-card__header-mobile" >
    <img src="/assets/images/logo-mobile.png" class="logo-mobile">
  </div>
  <div class="login-card__header" ubi-curve-header>
    <div class="login-card__header-text">
      Login
    </div>
  </div>
  <ng-container *ngIf="challengeName">
    <div class="go-back" (click)="goBack()">
      <img src="/assets/icons/arrow-left-icon.svg" class="go-back__img">
      <span class="go-back__text">Go back</span>
    </div>
  </ng-container>
  <img src="/assets/images/logo-large.png" class="logo">
  <ng-container *ngIf="ninetyType === 'ninetyDaysChangePasswordRequired' || ninetyType === 'resetPasswordRequired'">
    <span class="ninety-message">Your password age is over 90 days, please click <a class="ninety-message__link" (click)="resetNow()">reset now</a> to reset your password before signing in</span>
  </ng-container>
  <ng-container *ngIf="ninetyType === 'ninetyDaysBlocked'">
    <span class="ninety-message">Your account has been deactivated, please kindly contact administrator to unlock your account</span>
  </ng-container>

  <!-- Start login form -->
  <ng-container *ngIf="!challengeName">
    <form (ngSubmit)="onSubmit()" class="login-form" [formGroup]="loginForm">
      <mat-form-field class="custom-mat-form-field login-form__field">
        <input matInput placeholder="Email" formControlName="username" id="username" autocomplete="email">
        <mat-error  *ngIf="showFormControlErrors(loginForm, 'username')">
          <span *ngIf="loginForm.get('username').errors?.email">Invalid email format</span>
          <span *ngIf="loginForm.get('username').errors?.required">Field is required</span>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="custom-mat-form-field login-form__field">
        <input matInput placeholder="Password" type="password" formControlName="password" id="password" autocomplete="current-password">
        <mat-error *ngIf="showFormControlErrors(loginForm, 'password')">
          <span *ngIf="loginForm.get('password').errors?.required">Field is required</span>
        </mat-error>
      </mat-form-field>
      <a class="link forgot-password-link" routerLink="/forgot-password">Forgot Your Password?</a>
      <button type="submit" mat-button class="btn btn_accent-gradient-rounded login-btn" [disabled]="loginForm.invalid" ubi-round-button>
        Login
      </button>
    </form>
  </ng-container>
  <!-- End login form -->

  <!-- Start complete new password form -->
  <ng-container *ngIf="challengeName === 'newPasswordRequired'">
    <form class="login-form" [formGroup]="completeLoginForm" (ngSubmit)="completeFirstLogin()">
      <span class="login-form__title">Complete New Password</span>
      <!-- Hidden fields to get full autocomplete browser functionality -->
      <input type="email" autocomplete="email" class="login-form__field_hidden">
      <input type="password" autocomplete="password" class="login-form__field_hidden">
      <!-- End hidden fields -->
      <mat-form-field class="custom-mat-form-field challenge-field">
        <input type="password" matInput placeholder="NEW PASSWORD" formControlName="newPassword" autocomplete="new-password">
        <mat-error *ngIf="showFormControlErrors(completeLoginForm, 'newPassword')">
          <span *ngIf="completeLoginForm.get('newPassword').errors?.required">Field is required</span>
          <span *ngIf="completeLoginForm.get('newPassword').errors?.pattern">
            Must contain at least one number, one symbol, one uppercase, and lowercase letter, and at least 8 or more characters.
          </span>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="custom-mat-form-field challenge-field">
        <input type="password" matInput placeholder="REPEAT PASSWORD" formControlName="confirmNewPassword" autocomplete="new-password">
        <mat-error *ngIf="showFormControlErrors(completeLoginForm, 'confirmNewPassword')">
          <span *ngIf="completeLoginForm.get('confirmNewPassword').errors?.required">Field is required</span>
          <span *ngIf="completeLoginForm.get('confirmNewPassword').errors?.pattern">
            Must contain at least one number, one symbol, one uppercase, and lowercase letter, and at least 8 or more characters.
          </span>
        </mat-error>
      </mat-form-field>
      <div class="login-card__actions">
        <button type="submit" mat-button class="btn btn_accent-gradient-rounded login-btn" [disabled]="completeLoginForm.invalid" ubi-round-button>
          Submit
        </button>
      </div>
    </form>
  </ng-container>
  <!-- End complete new password form -->

  <!-- Start reset password form -->
  <ng-container *ngIf="challengeName === 'resetPasswordRequired' || challengeName === 'ninetyDaysChangePasswordRequired'">
    <form class="login-form" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
      <span class="login-form__title">Reset Password</span>
      <mat-form-field class="custom-mat-form-field challenge-field">
        <input type="text" matInput placeholder="CODE" formControlName="code" autocomplete="one-time-code">
        <mat-error *ngIf="showFormControlErrors(resetPasswordForm, 'code')">
          <span *ngIf="resetPasswordForm.get('code').errors?.required">Field is required</span>
          <span *ngIf="resetPasswordForm.get('code').errors?.pattern">{{ 'account_setting.errors' | translate }}</span>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="custom-mat-form-field challenge-field">
        <input type="password" matInput placeholder="NEW PASSWORD" formControlName="newPassword" autocomplete="new-password">
        <mat-error *ngIf="showFormControlErrors(resetPasswordForm, 'newPassword')">
          <span *ngIf="resetPasswordForm.get('newPassword').errors?.required">Field is required</span>
          <span *ngIf="resetPasswordForm.get('newPassword').errors?.pattern">
            Must contain at least one number, one symbol, one uppercase, and lowercase letter, and at least 8 or more characters.
          </span>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="custom-mat-form-field challenge-field">
        <input type="password" matInput placeholder="REPEAT PASSWORD" formControlName="confirmNewPassword" autocomplete="new-password">
        <mat-error *ngIf="showFormControlErrors(resetPasswordForm, 'confirmNewPassword')">
          <span *ngIf="resetPasswordForm.get('confirmNewPassword').errors?.required">Field is required</span>
          <span *ngIf="resetPasswordForm.get('confirmNewPassword').errors?.pattern">
            Must contain at least one number, one symbol, one uppercase, and lowercase letter, and at least 8 or more characters.
          </span>
        </mat-error>
      </mat-form-field>
      <div class="login-card__actions">
        <button type="submit" mat-button class="btn btn_accent-gradient-rounded login-btn" [disabled]="resetPasswordForm.invalid" ubi-round-button>
          Submit
        </button>
      </div>
    </form>
  </ng-container>
  <!-- End reset password form -->

  <!-- Start Mfa confirm login form -->
  <ng-container *ngIf="challengeName === 'mfaRequired'">
    <form class="login-form" [formGroup]="mfaConfirmForm" (ngSubmit)="confirmMfaLogin()">
      <span class="login-form__title">Multi-factor Authentication</span>
      <mat-form-field class="custom-mat-form-field challenge-field">
        <input type="text" matInput placeholder="MFA CODE" formControlName="code" autocomplete="one-time-code">
        <mat-error *ngIf="showFormControlErrors(mfaConfirmForm, 'code')">
          <span *ngIf="mfaConfirmForm.get('code').errors?.required">Field is required</span>
          <span *ngIf="mfaConfirmForm.get('code').errors?.pattern">{{ 'account_setting.errors' | translate }}</span>
        </mat-error>
      </mat-form-field>
      <div class="login-card__actions">
        <button type="submit" mat-button class="btn btn_accent-gradient-rounded login-btn" [disabled]="mfaConfirmForm.invalid" ubi-round-button>
          Verify
        </button>
      </div>
    </form>
  </ng-container>
  <!-- End Mfa confirm login form -->

</div>
<div class="copyright">
  <span>Copyright © 2019 Cynopsis Solutions Pte. Ltd.</span>
  <span>All Rights Reserved</span>
</div>
